import { defineAsyncComponent } from 'vue'

import elActionBtn from './elActionBtn.vue'
import elBootstrapDropdown from './elBootstrapDropdown.vue'
import elCallout from './elCallout.vue'
import elCaretBtn from './elCaretBtn.vue'
import elConfirmModal from './elConfirmModal.vue'
import elDnaLoader from './elDnaLoader.vue'
import elDotLoader from './elDotLoader.vue'
import elEntityBox from './elEntityBox.vue'
import elIcon from './elIcon.vue'
import elInlineEditBox from './elInlineEditBox.vue'
import elLiveBtn from './elLiveBtn.vue'
import elPasswordInput from './elPasswordInput.vue'
import elRange from './elRange.vue'
import elRemovableListItem from './elRemovableListItem.vue'
import elSegmentedControl from './elSegmentedControl.vue'
import elTable from './elTable.vue'
import elToken from './elToken.vue'
import elWizard from './elWizard.vue'
import ListFilterBar from './ListFilterBar.vue'
import HiddenKeyValue from './HiddenKeyValue.vue'
import HorizontalSplitContainer from './HorizontalSplitContainer.vue'
import ToggleButton from './toggle-button/ToggleButton.vue'
import PlaceholderBlock from './placeholder/PlaceholderBlock.vue'
import PlaceholderElement from './placeholder/PlaceholderElement.vue'
import TextEllipsis from './TextEllipsis.vue'
import CircleProgressBar from './CircleProgressBar.vue'
import elCarousel from './elCarousel.vue'

const elTimeRangeControls = defineAsyncComponent(() => import('./elTimeRangeControls.vue'))

export {
  elActionBtn,
  elBootstrapDropdown,
  elCallout,
  elCaretBtn,
  elConfirmModal,
  elDnaLoader,
  elDotLoader,
  elEntityBox,
  elInlineEditBox,
  elIcon,
  elLiveBtn,
  elPasswordInput,
  elRange,
  elRemovableListItem,
  elSegmentedControl,
  elTable,
  elTimeRangeControls,
  elToken,
  elWizard,
  HiddenKeyValue,
  HorizontalSplitContainer,
  ToggleButton,
  PlaceholderBlock,
  PlaceholderElement,
  ListFilterBar,
  TextEllipsis,
  CircleProgressBar,
  elCarousel
}
